module.exports = __webpack_public_path__ + "img/flexrp.ab8f4c80.png";